


























































import { Vue, Component, Prop } from "vue-property-decorator";
import { EnterpriseInfo } from "../../_models/enterpriseInfo";
import CardTitle from "../CardTitle.vue";
import DetailsInfo from "../Details/DetailsInfo.vue";
import EditDialog from "../Edit/EditDialog.vue";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import { UserInfo } from "../../_models/userInfo";
import ChangePassword from "../ChangePassword.vue";
import { userUtils } from "../../_utils/userUtils";
import WelcomeDialog from "../../components/Dialogs/WelcomeDialog.vue";
import { readUserInfo } from "../../_store/user.module";

@Component({
  components: {
    CardTitle,
    DetailsInfo,
    EditDialog,
    ChangePassword,
    WelcomeDialog
  }
})
export default class EnterpriseDetails extends Vue {
  @Prop() checkComplete!: boolean;
  private isComplete: boolean;
  private enterpriseData: EnterpriseInfo;
  private titleParams: object;
  private ruolo: number[];

  private welcomeDialog: boolean;

  constructor() {
    super();
    this.isComplete = false;
    this.titleParams = {
      title: "Dettagli Azienda",
      cols: "12",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.enterpriseData = {
      idAzienda: 0,
      denominazioneAzienda: "",
      titolo: "",
      cognomeRappresentanteAzienda: "",
      nomeRappresentanteAzienda: "",
      dataNascitaRappresentante: "",
      statoNascitaRappresentante: "",
      luogoNascitaRappresentante: "",
      comuneAzienda: "",
      idCapComuneAzienda: 0,
      provinciaAzienda: "",
      indirizzoAzienda: "",
      telefono1Azienda: "",
      telefono2Azienda: "",
      faxAzienda: "",
      emailAzienda: "",
      pecAzienda: "",
      sitoAzienda: "",
      attivitàAzienda: "",
      dipendentiAzienda: "",
      committenzaAzienda: "",
      associata: false,
      artigiana: false,
      pIva: "",
      codAzienda: "",
      idAteco: "",
      // idIstat: "",
      // codAteco: "",
      // codIstat: "",
      descrizioneAteco: "",
      descrizioneIstat: "",
      cap: "",
      idNazioneAzienda: "",
      nazioneAzienda: "",
      idStatoUtente: 0,
      codRappresentate: "",
      confCommercio: false,
      altraAssociazione: false
    };
    this.ruolo = [];
    this.welcomeDialog = false;
  }
  back() {
    window.history.back();
  }

  searchStateName() {
    data
      .dispatchStatiList(this["$store"])
      .then(() => {
        var states = data.readStatiList(this["$store"]);
        // var stateName: string = "";
        states.forEach(element => {
          if (element.idStato === this.enterpriseData.idNazioneAzienda) {
            bus.$emit("stateName", element.nomeStato);
          }
        });
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  searchComuneName() {
    var payload = {
      località: "",
      provincia: ""
    }
    data
      .dispatchComuniList(this["$store"])
      .then(() => {
        var comuni = data.readComuniList(this["$store"]);
        comuni.forEach(element => {
          if (element.id === this.enterpriseData.idCapComuneAzienda) {
            payload.località = element.località
            payload.provincia = element.idProvincia
            bus.$emit("comuneName", payload);
          }
        });
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  created() {
    var userStatus = localStorage.getItem("userStatus");
    user.dispatchSetEnterpriseInfo(this["$store"]).then(() => {
      this.enterpriseData = user.readEnterpriseInfo(this["$store"]);
      this.isComplete = userUtils.checkEnterpriseInfo(this.enterpriseData);
      if (
        this.checkComplete !== undefined &&
        this.checkComplete === true &&
        userStatus !== undefined &&
        userStatus !== "5"
      ) {
        if (this.isComplete === false) {
          bus.$emit("incompleteInfo");
        }
      }
      this.searchStateName();
      this.searchComuneName()
    });

    bus.$on("editedEnterprise", () => {
      this.enterpriseData = user.readEnterpriseInfo(this["$store"]);
      this.searchStateName();
      this.searchComuneName()
    });

    bus.$on("openWelcomeDialog", () => {
      bus.$emit("openWelcome", "enterprise");
    });
  }

  mounted() {
    var userInfo: UserInfo = user.readUserInfo(this["$store"]);
    this.ruolo = userInfo.ruoloUtente;
  }
}
